module.exports = __webpack_public_path__ + "static/media/s-plus.ae5e5fff.svg";